<template>
  <div>
    <h2 class="title is-2">New Post</h2>
    <form @submit.prevent="createPost()">

      <b-field label="Title">
        <b-input v-model="post.attributes.title" size="is-large"></b-input>
      </b-field>

      <b-field label="Post Date">
        <b-datetimepicker
          v-model="post.postedAt"
          rounded
          placeholder="Click to select..."
          :timepicker="{ hourFormat: '12' }"
          horizontal-time-picker>
        </b-datetimepicker>
      </b-field>

      <b-field label="Location">
        <b-input v-model="post.attributes.location"></b-input>
      </b-field>

      <div class="buttons">
        <b-button type="is-primary" native-type="submit" size="is-large" expanded>Continue</b-button>
      </div>

      <div class="has-text-centered">
        <router-link to="/">or cancel</router-link>
      </div>

    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EditablePost } from '@/utils/editable'
export default {
  data () {
    return {
      post: new EditablePost({
        title: '',
        postedAt: new Date().toJSON(),
        location: ''
      })
    }
  },
  computed: mapState([ 'profile' ]),
  methods: {
    async createPost () {
      this.post.attributes.profileID = this.profile.id
      const post = await this.post.save()
      this.$router.push({ name: 'post.edit', params: { id: post.id }})
    }
  }
}
</script>
